// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ActionLink from '../../../../shared/components/action-link';
import {FormattedMessage} from 'react-intl';
import ProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import {getProductStatusClassName} from '../../../shared/services/product-status';

function handleClick() {

    this.onOpenStatusChangeModal(this.product);

}

const ProductSearchStatusLink = props =>

    <div className='product-status-link'>
        <span className='product-status-label'>
            <FormattedMessage id='STATUS'/>
        </span>
        {props.product.status.length &&
            <span className='status'>
                <span className={getProductStatusClassName(props.product.status[0])}/>
                <ActionLink
                    className='product-status-data'
                    isDisabled={false}
                    label={props.product.status[0].value}
                    onClick={props::handleClick}
                    type={'button-link'}
                />
            </span>
        }
    </div>;

ProductSearchStatusLink.displayName = 'ProductSearchStatusLink';
ProductSearchStatusLink.propTypes = {
    onOpenStatusChangeModal: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(ProductSearchResult).isRequired
};

export default ProductSearchStatusLink;



// WEBPACK FOOTER //
// ./src/product/search/components/product-search-status-link/index.js